// Listening dates are calendar days stored as UTC midnight (YYYY-MM-DDT00:00Z).

/** The furthest time zone ahead of UTC is UTC+14. */
const MAX_UTC_OFFSET_MS = 14 * 60 * 60_000

/** Today's calendar date in the device time zone, for date pickers. */
export function localCalendarDate(date = new Date()): string {
	return [
		date.getFullYear(),
		String(date.getMonth() + 1).padStart(2, '0'),
		String(date.getDate()).padStart(2, '0'),
	].join('-')
}

/** The latest calendar date that is already "today" somewhere, so no user's today is rejected as future. */
export function latestCalendarDate(now = Date.now()): string {
	return new Date(now + MAX_UTC_OFFSET_MS).toISOString().slice(0, 10)
}
